import dagre from "dagre";

export const alignNodesWithDagLayout = (
  nodes,
  edges,
  direction = "RL",
  excludedType = null,
  reactFlowInstance
) => {
  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setGraph({ rankdir: direction, nodesep: 50, ranksep: 50 });
  dagreGraph.setDefaultEdgeLabel(() => ({}));

  // Separate nodes
  const excludedNodes = nodes.filter((node) => node.id === "notes");
  const connectedNodes = nodes.filter(
    (node) =>
      node.type !== excludedType &&
      node.id !== "notes" &&
      edges.some((edge) => edge.source === node.id || edge.target === node.id)
  );
  const isolatedNodes = nodes.filter(
    (node) =>
      node.type !== excludedType &&
      node.id !== "notes" &&
      !edges.some((edge) => edge.source === node.id || edge.target === node.id)
  );

  // Add connected nodes to the Dagre graph
  connectedNodes.forEach((node) => {
    let nodeHeight = 210;
    if (Array.isArray(node.data?.handles)) {
      const extraHandles = node.data.handles.length - 1;
      nodeHeight += extraHandles > 0 ? extraHandles * 60 : 0;
    }

    dagreGraph.setNode(node.id, { width: 230, height: nodeHeight });
  });

  // Add edges
  edges.forEach((edge) => {
    if (
      connectedNodes.some((node) => node.id === edge.source) &&
      connectedNodes.some((node) => node.id === edge.target)
    ) {
      dagreGraph.setEdge(edge.source, edge.target);
    }
  });

  // Perform layout for connected nodes
  dagre.layout(dagreGraph);

  // Update positions for connected nodes
  const updatedConnectedNodes = connectedNodes.map((node) => {
    const dagNode = dagreGraph.node(node.id);

    let nodeHeight = 210;
    if (Array.isArray(node.data?.handles)) {
      const extraHandles = node.data.handles.length - 1;
      nodeHeight += extraHandles > 0 ? extraHandles * 60 : 0;
    }

    return {
      ...node,
      data: {
        ...node.data,
        height: nodeHeight, // Optionally update the height in data
      },
      position: { x: dagNode.x, y: dagNode.y },
    };
  });

  // Position excluded nodes at the top
  const maxNodeHeight = Math.max(
    ...nodes.map((node) => {
      if (Array.isArray(node.data?.handles)) {
        const extraHandles = node.data.handles.length - 1;
        return 210 + (extraHandles > 0 ? extraHandles * 60 : 0);
      }
      return 210;
    })
  );

  const updatedExcludedNodes = excludedNodes.map((node) => ({
    ...node,
    position: { x: 50, y: 50 },
  }));

  // Align isolated nodes below connected nodes
  const maxY =
    Math.max(
      ...updatedConnectedNodes.map(
        (node) => node.position.y + (node.data?.height || 210)
      )
    ) || maxNodeHeight;

  const updatedIsolatedNodes = isolatedNodes.map((node) => {
    let nodeHeight = 210;
    if (Array.isArray(node.data?.handles)) {
      const extraHandles = node.data.handles.length - 1;
      nodeHeight += extraHandles > 0 ? extraHandles * 60 : 0;
    }

    return {
      ...node,
      data: {
        ...node.data,
        height: nodeHeight,
      },
      position: { x: 50, y: maxY + maxNodeHeight },
    };
  });

  // Combine all nodes
  const updatedNodes = [
    ...updatedExcludedNodes,
    ...updatedConnectedNodes,
    ...updatedIsolatedNodes,
  ];

  // Scroll or zoom to excluded nodes
  if (reactFlowInstance && excludedNodes.length > 0) {
    const centerX =
      excludedNodes.reduce((sum, node) => sum + node.position.x, 0) /
      excludedNodes.length;
    const centerY =
      excludedNodes.reduce((sum, node) => sum + node.position.y, 0) /
      excludedNodes.length;

    reactFlowInstance.setCenter(centerX, centerY, { zoom: 0.5 });
  }

  return { nodes: updatedNodes, edges };
};
